import img1 from "../assets/img/carrousel-img/HerbstmotiveLichtenberg_27.10.2020_011_FotoCBuchen.webp";
import img2 from "../assets/img/carrousel-img/Lichtenberg Ortsmitte_04.10.2009_004FotoCBuchen.webp";
import img3 from "../assets/img/carrousel-img/Lichtenberg vom Kran_10.05.2011_018FotoCBuchen.webp";
import img4 from "../assets/img/carrousel-img/Lichtenberg_05.05.2014_015CBuchen.webp";
import img5 from "../assets/img/carrousel-img/Rundflug v.Katzwinkel_07.09.2014_122FotoCBuchen.webp";
import img6 from "../assets/img/carrousel-img/Pfarrheim-Lichtenberg_26.03.2017_002_FotoCBuchen.webp";
import img7 from "../assets/img/carrousel-img/FeuerwehrLichtenbergArchivCBuchen.webp";
import img8 from "../assets/img/carrousel-img/Lichtenberg-um-1910ArchivCBuchen_neu.webp";
import img9 from "../assets/img/carrousel-img/Lichtenberg-vom-Kran_10.05.2011_006FotoCBuchen.webp";
import img10 from "../assets/img/carrousel-img/Kapelle-Lichtenberg-Friedhof-alt_27.05.2011_002FotoCBuchen.webp";
import img11 from "../assets/img/carrousel-img/Rinnchen-Lichtenberg_13.09.2011_005FotoCBuchen.webp";
import img12 from "../assets/img/carrousel-img/Rundflug-v.Katzwinkel_10.10.2010_179aFotoCBuchen.webp";

const carrouselData = [
  {
    img: img1,
    text: "St. Joseph - Lichtenberg",
    sub: "",
  },
  {
    img: img11,
    text: "Rinnchen",
    sub: "",
  },
  {
    img: img3,
    text: "Morsbacher Straße",
    sub: "",
  },
  {
    img: img4,
    text: "Kännchenbrunnen",
    sub: "",
  },
  {
    img: img5,
    text: "Lichtenberg von oben",
    sub: "",
  },
  {
    img: img6,
    text: "Pfarrheim Lichtenberg",
    sub: "",
  },
  {
    img: img7,
    text: "Feuerwehr Lichtenberg",
    sub: "",
  },
  {
    img: img8,
    text: "Lichtenberg 1910",
    sub: "",
  },
  {
    img: img9,
    text: "Grundschule",
    sub: "",
  },
  {
    img: img12,
    text: "Lichtenberg von oben",
    sub: "",
  },
];
export default carrouselData;
